import DownloadIcon from "@assets/images/down-arrow.svg";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { FilterProps } from "../../types";
import Filter from "../Filter";
import { IFilter } from "../Filter/types";
import OrderFilterTabs from "../OrderFilterTabs";
import { SearchBarProps } from "../SearchBar";
import SearchInput from "../SearchBar/SearchInput";
import { FilterTab } from "../TableFilter";

export interface FilterBarProps<TKeys extends string = string>
  extends FilterProps<TKeys>,
    SearchBarProps {
  activeTab;
  filterStructure: IFilter<TKeys>;
  queryVariables;
  isDownloadVisible?: boolean;
  isAllAtStart?: boolean;
}

const useStyles = makeStyles(
  theme => ({
    downloadButton: {
      display: "flex",
      justifyContent: "flex-end",
      padding: "0 30px",
      width: "100%"
    },
    root: {
      borderBottom: `1px solid ${theme.palette.divider}`,
      display: "flex",
      flexWrap: "wrap",
      padding: theme.spacing(1, 3)
    },
    tabActionButton: {
      marginLeft: theme.spacing(2),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }
  }),
  {
    name: "OrderFilterBar"
  }
);

const OrderFilterBar: React.FC<FilterBarProps> = props => {
  const {
    activeTab,
    allTabLabel,
    currencySymbol,
    filterStructure,
    currentTab,
    initialSearch,
    queryVariables,
    searchPlaceholder,
    tabs,
    onAll,
    onSearchChange,
    onFilterChange,
    onTabChange,
    onTabDelete,
    onTabSave,
    download,
    isDownloadVisible,
    isAllAtStart
  } = props;

  const classes = useStyles(props);
  const intl = useIntl();

  const isSearchTermInLocalStorage =
    localStorage.getItem("orderFilters") !== null &&
    JSON.parse(localStorage.getItem("orderFilters")).filter(
      x => x.data.query === queryVariables.filter.search
    ).length > 0;

  const DEFAULT_TABS_LAST_INDEX = 9;

  const isCustomFilter =
    activeTab !== undefined &&
    activeTab > DEFAULT_TABS_LAST_INDEX &&
    isSearchTermInLocalStorage;

  const hasSelectedDefaultTab = queryVariables.filter.smopStatus !== null;

  const hasSearchTerms =
    queryVariables.filter.search !== undefined &&
    queryVariables.filter.search !== "";

  const showCustomFilterTab =
    queryVariables.filter.smopStatus === null &&
    queryVariables.filter.search !== undefined &&
    queryVariables.filter.search !== "" &&
    isSearchTermInLocalStorage === false;

  const displayTabAction = hasSelectedDefaultTab
    ? null
    : isCustomFilter
    ? "delete"
    : "save";

  return (
    <>
      <OrderFilterTabs currentTab={currentTab}>
        {isAllAtStart ? (
          <FilterTab label={allTabLabel} onClick={onAll} />
        ) : null}
        {tabs.map((tab, tabIndex) => (
          <FilterTab
            onClick={() => onTabChange(isAllAtStart ? tabIndex + 1 : tabIndex)}
            label={tab}
            key={tabIndex}
          />
        ))}
        {!isAllAtStart ? (
          <FilterTab label={allTabLabel} onClick={onAll} />
        ) : null}
        {showCustomFilterTab && (
          <FilterTab
            onClick={() => undefined}
            label={intl.formatMessage({
              defaultMessage: "Custom Filter"
            })}
          />
        )}
        <div id="cmpDownloadStatusTab" className={classes.downloadButton}>
          {isDownloadVisible && (
            <IconButton
              id="btnDownloadStatus"
              color="primary"
              onClick={download}
            >
              <img
                id="imgDownloadStatus"
                src={DownloadIcon}
                style={{ width: "15px" }}
              />
            </IconButton>
          )}
        </div>
      </OrderFilterTabs>
      <div className={classes.root}>
        <Filter
          currencySymbol={currencySymbol}
          menu={filterStructure}
          onFilterAdd={onFilterChange}
        />
        <SearchInput
          initialSearch={initialSearch}
          placeholder={searchPlaceholder}
          onSearchChange={onSearchChange}
        />
        {displayTabAction &&
          (displayTabAction === "save" && hasSearchTerms ? (
            <Button
              className={classes.tabActionButton}
              color="primary"
              onClick={onTabSave}
            >
              <FormattedMessage
                defaultMessage="Save Search"
                description="button"
              />
            </Button>
          ) : (
            displayTabAction === "delete" && (
              <Button
                className={classes.tabActionButton}
                color="primary"
                onClick={onTabDelete}
              >
                <FormattedMessage
                  defaultMessage="Delete Search"
                  description="button"
                />
              </Button>
            )
          ))}
      </div>
    </>
  );
};
OrderFilterBar.displayName = "OrderFilterBar";
export default OrderFilterBar;
